export default __webpack_public_path__ + "static/media/icon-asset-total.318aa202.svg";